var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.editBtn)?_c('edit-btn',{on:{"click":function($event){return _vm.$emit('edit',_vm.item)}}}):_vm._e(),_c('remove-btn',{attrs:{"loading":_vm.removeProgress},on:{"remove":_vm.removeItem}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }